<template>
  <div>
    <div>cardManage</div>
  </div>
</template>

<script>
export default {
  name: "CardManage",
  props: {

  },
  data() {
    return {

    };
  },
  components: {

  },
  created() {

  },
  mounted() {

  },
  methods: {

  }
};
</script>
<style scoped lang='scss'>
</style>
